import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import produce from 'immer';
import ACTIONS from '../../actions';
import getDotProp from '../../../utils/getDotProp';
var initialState = {};
export var dataReducer = function dataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.GRID_DATA_GET:
      {
        return state;
      }

    case ACTIONS.GRID_DATA_GET_RESOLVED:
      {
        var _action$view = action.view,
            dataKey = _action$view.dataKey,
            idKeyProp = _action$view.idKeyProp;
        var Data = action.payload.Data;
        var nextState = produce(state, function (draft) {
          draft[dataKey] = draft[dataKey] || {};
          Data.map(function (item) {
            var itemId = getDotProp(item, idKeyProp);
            var itemData = draft[dataKey][itemId];

            if (!itemData) {
              draft[dataKey][itemId] = item;
            } else {
              draft[dataKey][itemId] = _objectSpread({}, draft[dataKey][itemId], item);
            }
          });
        });
        return nextState;
      }

    case ACTIONS.ITEM_GET_RESOLVED:
      {
        var _action$data = action.data,
            _dataKey = _action$data.dataKey,
            _idKeyProp = _action$data.idKeyProp,
            id = _action$data.id;
        var item = action.payload;

        var _nextState = produce(state, function (draft) {
          draft[_dataKey] = draft[_dataKey] || {};
          var itemId = id;

          if (_idKeyProp != null) {
            itemId = getDotProp(item, _idKeyProp);

            if (itemId !== id) {
              // eslint-disable-next-line no-console
              console.warn("Id mismatch between client request (dictated by DataItem id: ".concat(id, ") and server response (dictated by idKeyProp: ").concat(_idKeyProp, " = ").concat(itemId, ")"));
            }
          }

          var itemData = draft[_dataKey][itemId];

          if (!itemData) {
            draft[_dataKey][itemId] = item;
          } else {
            if (typeof itemData === 'string') {
              draft[_dataKey][itemId] = item;
            } else {
              draft[_dataKey][itemId] = _objectSpread({}, draft[_dataKey][itemId], item);
            }
          }
        });

        return _nextState;
      }

    case ACTIONS.ITEM_DELETE:
    case ACTIONS.ITEM_RENAME:
      {
        var _item = action.item,
            _action$data2 = action.data,
            _dataKey2 = _action$data2.dataKey,
            _idKeyProp2 = _action$data2.idKeyProp,
            _id = _action$data2.id;

        var _nextState2 = produce(state, function (draft) {
          draft[_dataKey2] = draft[_dataKey2] || {};
          var itemId = _id;

          if (_idKeyProp2 != null) {
            if (_item) itemId = getDotProp(_item, _idKeyProp2);

            if (itemId !== _id) {
              // eslint-disable-next-line no-console
              console.warn("Id mismatch between client request (dictated by DataItem id: ".concat(_id, ") and server response (dictated by idKeyProp: ").concat(_idKeyProp2, " = ").concat(itemId, ")"));
            }
          }

          var itemData = draft[_dataKey2][itemId];
          if (!itemData) return;
          var marker = {};
          if (action.type === ACTIONS.ITEM_DELETE) marker.__deleting = true;else if (action.type === ACTIONS.ITEM_RENAME) marker.__updating = true;

          if (typeof itemData === 'string') {
            draft[_dataKey2][itemId] = _objectSpread({
              value: itemData
            }, marker);
          } else {
            draft[_dataKey2][itemId] = _objectSpread({}, draft[_dataKey2][itemId], marker);
          }
        });

        return _nextState2;
      }

    case ACTIONS.ITEM_DELETE_FAILED:
    case ACTIONS.ITEM_RENAME_FAILED:
      {
        var _item2 = action.item,
            _action$data3 = action.data,
            _dataKey3 = _action$data3.dataKey,
            _idKeyProp3 = _action$data3.idKeyProp,
            _id2 = _action$data3.id;

        var _nextState3 = produce(state, function (draft) {
          draft[_dataKey3] = draft[_dataKey3] || {};
          var itemId = _id2;

          if (_idKeyProp3 != null) {
            if (_item2) itemId = getDotProp(_item2, _idKeyProp3);

            if (itemId !== _id2) {
              // eslint-disable-next-line no-console
              console.warn("Id mismatch between client request (dictated by DataItem id: ".concat(_id2, ") and server response (dictated by idKeyProp: ").concat(_idKeyProp3, " = ").concat(itemId, ")"));
            }
          }

          var itemData = draft[_dataKey3][itemId];
          if (!itemData) return;
          var marker = {};
          if (action.type === ACTIONS.ITEM_DELETE_FAILED) marker.__deleting = false;else if (action.type === ACTIONS.ITEM_RENAME_FAILED) marker.__updating = false;

          if (typeof itemData === 'string') {
            draft[_dataKey3][itemId] = _objectSpread({
              value: itemData
            }, marker);
          } else {
            draft[_dataKey3][itemId] = _objectSpread({}, draft[_dataKey3][itemId], marker);
          }
        });

        return _nextState3;
      }

    case ACTIONS.ITEM_DELETE_RESOLVED: //item does not exist any more

    case ACTIONS.ITEM_RENAME_RESOLVED:
      {
        var _item3 = action.item,
            _action$data4 = action.data,
            _dataKey4 = _action$data4.dataKey,
            _idKeyProp4 = _action$data4.idKeyProp,
            _id3 = _action$data4.id;

        var _nextState4 = produce(state, function (draft) {
          draft[_dataKey4] = draft[_dataKey4] || {};
          var itemId = _id3;

          if (_idKeyProp4 != null) {
            if (_item3) itemId = getDotProp(_item3, _idKeyProp4);

            if (itemId !== _id3) {
              // eslint-disable-next-line no-console
              console.warn("Id mismatch between client request (dictated by DataItem id: ".concat(_id3, ") and server response (dictated by idKeyProp: ").concat(_idKeyProp4, " = ").concat(itemId, ")"));
            }
          }

          var itemData = draft[_dataKey4][itemId];
          if (!itemData) return;
          var marker = {};
          if (action.type === ACTIONS.ITEM_DELETE_RESOLVED) marker.__deleting = false;else if (action.type === ACTIONS.ITEM_RENAME_RESOLVED) marker.__updating = false;

          if (typeof itemData === 'string') {
            draft[_dataKey4][itemId] = _objectSpread({
              value: itemData
            }, marker);
          } else {
            draft[_dataKey4][itemId] = _objectSpread({}, draft[_dataKey4][itemId], marker);
          }
        });

        return _nextState4;
      }

    default:
      return state;
  }
};
export default dataReducer;